export default "__VITE_ASSET__B06Y4Yxf__"